var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSmartSuiteHex(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 102,
    height: 109,
    viewBox: "0 0 102 109",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_22098_1505)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M47.8696 15.3347C49.8067 14.2163 52.1933 14.2163 54.1304 15.3347L79.0465 29.72C80.9836 30.8384 82.1769 32.9053 82.1769 35.1421V63.9126C82.1769 66.1494 80.9836 68.2163 79.0465 69.3347L54.1304 83.72C52.1933 84.8384 49.8067 84.8384 47.8696 83.72L22.9535 69.3347C21.0164 68.2163 19.8231 66.1494 19.8231 63.9126V35.1421C19.8231 32.9053 21.0164 30.8384 22.9535 29.72L47.8696 15.3347Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.8782 61.3765L50.8477 49.7154L60.9903 43.8618L61.0245 55.5167L50.8782 61.3765Z",
    fill: "url(#paint0_linear_22098_1505)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.8778 61.3783L40.8006 55.5188L40.7603 43.8604L50.8472 49.7171L50.8778 61.3783Z",
    fill: "#D0D2FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.8472 49.7169L40.7603 43.8602L50.9127 38.0039L60.99 43.8632L50.8472 49.7169Z",
    fill: "#D8E5FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.7207 35.4332C66.0988 36.2287 66.1015 38.2169 64.7256 39.0161L53.0234 45.8133C51.7409 46.5583 50.1577 46.5603 48.8734 45.8184L37.0806 39.0072C35.7032 38.2117 35.7005 36.2244 37.0756 35.425L48.769 28.6281C50.0514 27.8828 51.6345 27.8803 52.9191 28.6218L64.7207 35.4332Z",
    fill: "url(#paint1_linear_22098_1505)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.1413 44.9033C32.7993 44.1238 31.1178 45.0951 31.1226 46.647L31.1646 60.3399C31.1689 61.7662 31.9291 63.0835 33.1619 63.801L44.9982 70.6893C46.3396 71.4701 48.0221 70.4998 48.0183 68.9477L47.9847 55.2477C47.9812 53.8192 47.2197 52.4999 45.9844 51.7824L34.1413 44.9033Z",
    fill: "url(#paint2_linear_22098_1505)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.876 51.7777C54.6299 52.4975 53.8637 53.8286 53.8672 55.2677L53.9008 68.98C53.9046 70.5251 55.5779 71.4879 56.9156 70.7149L68.869 63.8074C70.1156 63.0871 70.8815 61.7551 70.8771 60.3154L70.8351 46.6127C70.8303 45.0684 69.1579 44.1064 67.8206 44.8788L55.876 51.7777Z",
    fill: "url(#paint3_linear_22098_1505)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.7915 55.4954V48.7666C42.0597 49.4859 44.7976 51.0464 45.604 51.5348C46.6119 52.1452 47.0093 52.5427 47.421 53.1672C47.7503 53.6669 47.9367 54.6057 47.9888 55.0127V59.6689L40.7915 55.4954Z",
    fill: "url(#paint4_linear_22098_1505)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M61.0596 55.4954V48.7666C59.7914 49.4859 57.0535 51.0464 56.2472 51.5348C55.2393 52.1452 54.8418 52.5427 54.4302 53.1672C54.1008 53.6669 53.9144 54.6057 53.8623 55.0127V59.6689L61.0596 55.4954Z",
    fill: "url(#paint5_linear_22098_1505)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.6551 42.509L53.1958 45.7409C51.7567 46.5928 49.9675 46.5913 48.5297 45.7371L43.0967 42.509L50.8617 38.1367L58.6551 42.509Z",
    fill: "#12199F"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_22098_1505",
    x: -4.05882,
    y: -0.237361,
    width: 110.118,
    height: 110.118,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 5.29412
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 9.52941
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0705808 0 0 0 0 0.0559722 0 0 0 0 0.216667 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_22098_1505"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_22098_1505",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_22098_1505",
    x1: 61.0066,
    y1: 55.5477,
    x2: 50.862,
    y2: 49.6907,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#89A5F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#718DE3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_22098_1505",
    x1: 50.8675,
    y1: 45.9733,
    x2: 50.8675,
    y2: 27.4231,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1A23CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#328FFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_22098_1505",
    x1: 40.7979,
    y1: 48.3015,
    x2: 37.1754,
    y2: 70.2094,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00E3F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#008EDC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_22098_1505",
    x1: 54.9424,
    y1: 70.7272,
    x2: 65.1499,
    y2: 41.164,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDA200"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FDD000"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_22098_1505",
    x1: 47.1168,
    y1: 52.3324,
    x2: 40.7915,
    y2: 55.058,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00C0EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00AFDF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_22098_1505",
    x1: 54.7343,
    y1: 52.3324,
    x2: 61.0596,
    y2: 55.058,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EC7B00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ED9500"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmartSuiteHex);
export default __webpack_public_path__ + "static/media/smart-suite-hex.65371222dcea35203f504a33fa79bb52.svg";
export { ForwardRef as ReactComponent };